import list from "./list";
import create from "./create";

const depositMatchOfferModule = {
  namespaced: true,
  modules: {
    list,
    create,
  },
};

export default depositMatchOfferModule;
